export default "__VITE_ASSET__LgVqdA54__"